import React from 'react';
import {array, string, object} from 'prop-types';
import {withRouteData} from 'react-static';
import Prismic from 'prismic-javascript';
import {RichText} from 'prismic-reactjs';
import linkResolver from '../utils/link-resolver';
import PrismicPreview from '../components/prismic-preview';
import PrismicLink from '../components/prismic-link';
import Banner from '../components/banner/banner';
import Title from '../components/title/title';
import Service from '../components/service/service';

const Services = props => (
  <PrismicPreview
    publishedContent={props}
    query={{predicates: Prismic.Predicates.at('document.type', 'services')}}
  >
    {({body, title, intro_text, button_label, button_link, banner_image}) => {
      const services = [];
      let tempServices = [];

      body.forEach(slice => {
        if (slice.slice_type === 'service') {
          tempServices.push(slice);
        }

        if (tempServices.length === 3) {
          services.push(tempServices);
          tempServices = [];
        }
      });

      return (
        <>
          {banner_image && <Banner image={banner_image.url} />}
          {title && (
            <Title
              title={RichText.asText(title)}
              text={RichText.render(intro_text, linkResolver)}
            />
          )}

          <div className="container">
            <div className="row">
              {services.length > 0 &&
                services.map(serviceGroup => (
                  <section
                    className="service-row container"
                    key={Math.random(3)}
                  >
                    <div className="row">
                      {serviceGroup.map(slice => (
                        <Service
                          key={RichText.asText(slice.primary.service_title)}
                          image={slice.primary.image}
                          title={RichText.asText(slice.primary.service_title)}
                          text={RichText.render(
                            slice.primary.text,
                            linkResolver
                          )}
                        />
                      ))}
                    </div>

                    <div className="button-container">
                      <PrismicLink
                        className="button btn-secondary"
                        link={button_link}
                      >
                        {button_label}
                      </PrismicLink>
                    </div>
                  </section>
                ))}
            </div>
          </div>
        </>
      );
    }}
  </PrismicPreview>
);

Services.propTypes = {
  body: array.isRequired,
  title: array.isRequired,
  intro_text: array.isRequired,
  banner_image: object.isRequired,
  button_label: string.isRequired,
  button_link: object.isRequired
};

export default withRouteData(Services);
